import { Grid } from '@mui/material';

import { useState } from 'react';

import ButtonComp from 'common/components/Button/ButtonComp';
import ModalEle from 'common/components/Modal/ModalEle';
import { CONTROL_TESTSCRIPT_ACTIONS_TYPE } from 'common/constants/TestScriptHubControlConstants';

import ControlTestStepModalHeader from '../ControlTestStepModalHeader/ControlTestStepModalHeader';

import styles from './ControlTestStepAddEditActions.module.scss';

interface IControlTestStepAddEditActions {
	title: string;
	openModal: boolean;
	handleClose: () => void;
	addTestScript: (data: any) => void;
	editTestScript: (text: string, index: number) => void;
	ModalHeaderImg: any;
	testScriptData?: string;
	type?: string;
	rowIndex: number;
}

const ControlTestStepAddEditActions = (
	props: IControlTestStepAddEditActions,
) => {
	const {
		openModal,
		title,
		handleClose,
		addTestScript,
		ModalHeaderImg,
		testScriptData,
		editTestScript,
		type,
		rowIndex,
	} = props;

	const [addTestStepData, setTestStepData] = useState<string>(
		testScriptData || '',
	);

	const { ADD_TEST_ACTION } = CONTROL_TESTSCRIPT_ACTIONS_TYPE;

	const handleModalClose = () => {
		handleClose();
	};

	const setTestScriptStepData = (event: any) => {
		setTestStepData(event?.target?.value);
	};

	const addTestScriptToList = () => {
		addTestScript(addTestStepData);
	};

	const editTestScriptToList = () => {
		editTestScript(addTestStepData, rowIndex);
	};

	return (
		<ModalEle open={openModal} handleClose={handleModalClose}>
			<Grid container xs={12} lg={12} sm={12} md={12} direction="row">
				<Grid
					direction="row"
					container
					item
					xs={12}
					lg={12}
					sm={12}
					md={12}
					spacing={1}
				>
					<ControlTestStepModalHeader
						title={title}
						handleModalClose={handleModalClose}
						ModalHeaderImg={ModalHeaderImg}
					/>
				</Grid>
				<Grid
					container
					item
					direction="row"
					xs={12}
					lg={12}
					sm={12}
					md={12}
					mt={2}
				>
					<Grid
						item
						xs={12}
						lg={12}
						sm={12}
						md={12}
						className={styles['add-control-test-step-label']}
					>
						Test step details{' '}
						<span className={styles['add-control-test-step-title-error']}>
							*
						</span>
					</Grid>
					<Grid item xs={12} lg={12} sm={12} md={12}>
						<textarea
							onChange={setTestScriptStepData}
							rows={6}
							data-testId="addtestmodal"
							className={styles['add-control-test-step-textarea']}
							value={addTestStepData}
						/>
					</Grid>
					<Grid
						item
						xs={12}
						lg={12}
						sm={12}
						md={12}
						className={styles['add-control-test-step-btngrp']}
					>
						<ButtonComp
							btnType="secondary"
							clickHandler={handleModalClose}
							data-testid="addtestmoal-cancel"
						>
							Cancel
						</ButtonComp>
						<ButtonComp
							btnType="primary"
							clickHandler={
								type === ADD_TEST_ACTION
									? addTestScriptToList
									: editTestScriptToList
							}
							disabled={
								addTestStepData === '' || addTestStepData === testScriptData
							}
							data-testid="addtestmodal-save"
						>
							Save
						</ButtonComp>
					</Grid>
				</Grid>
			</Grid>
		</ModalEle>
	);
};

export default ControlTestStepAddEditActions;
